import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaVirtualScroller from './VaVirtualScroller.vue'

export const VaVirtualScroller = withConfigTransport(_VaVirtualScroller)
